import { useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { BellRinging } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { soundOn, chime, firstAlert, unlockAudio } from "@/lib/nowAlert";

const mmss = (s) => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

// Pemantau global pesanan Konsultasi Sekarang yang sudah lunas & menunggu diterima.
export const ConsultNowAlert = () => {
  const [cur, setCur] = useState(null);
  const [skew, setSkew] = useState(0);
  const [, tick] = useState(0);
  const nav = useNavigate();
  const loc = useLocation();
  const load = useCallback(() => api.get("/consult-now/me").then((r) => {
    setSkew(r.data.server_ts - Date.now() / 1000);
    const c = r.data.current;
    const waiting = c && c.phase === "await_accept" ? c : null;
    setCur(waiting);
    if (waiting && firstAlert(`${waiting.reservation_id}:${Math.round(waiting.accept_deadline_ts || 0)}`) && soundOn()) chime();
    return true;
  }).catch((e) => (e?.response?.status === 403 ? "stop" : true)), []);
  useEffect(() => {
    let id;
    load().then((res) => { if (res !== "stop") id = setInterval(load, 10000); });
    const t = setInterval(() => tick((x) => x + 1), 1000);
    return () => { clearInterval(id); clearInterval(t); };
  }, [load]);
  useEffect(() => {
    const unlock = () => { if (soundOn()) unlockAudio(); };
    window.addEventListener("pointerdown", unlock, { once: true });
    return () => window.removeEventListener("pointerdown", unlock);
  }, []);
  if (!cur) return null;
  const left = Math.max(0, Math.round((cur.accept_deadline_ts || 0) - (Date.now() / 1000 + skew)));
  return (
    <div data-testid="consult-now-alert" className="fixed inset-x-3 bottom-20 z-[60] mx-auto max-w-md rounded-2xl border border-rose-200 bg-white p-3 shadow-2xl lg:bottom-6 lg:left-auto lg:right-6 lg:mx-0">
      <p className="flex items-center gap-1.5 text-sm font-extrabold text-rose-700"><BellRinging size={18} weight="fill" className="animate-pulse" /> Pesanan Konsultasi Sekarang baru</p>
      <p data-testid="consult-now-alert-service" className="mt-0.5 text-sm font-semibold text-slate-700">{cur.layanan}</p>
      <div className="mt-2 flex items-center justify-between gap-2">
        <span data-testid="consult-now-alert-countdown" className="text-xs font-bold text-rose-600">Terima dalam {mmss(left)}</span>
        {loc.pathname !== "/konsultasi-saya" && (
          <button data-testid="consult-now-alert-open" onClick={() => nav("/konsultasi-saya")} className="rounded-full bg-emerald-600 px-4 py-1.5 text-xs font-bold text-white">Buka Pesanan</button>
        )}
      </div>
    </div>
  );
};
